export default __webpack_public_path__ + "resources/icons/n500-0fa4.webp";